import React, { useState } from 'react'
import "./Sidebar.css"
import Home from "../Home/Home";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import SidebarList from './SidebarList';
 


const Sidebar = ({theme, changeTheme}) => {

    const [expnadSidbar, setExpnadSidbar] = useState(true)

    const handleExpendClick = () => {
        setExpnadSidbar(!expnadSidbar);
    }

    return (
        <div className="container-fluid sidebar-section">
            <div className={expnadSidbar ? "sidebar-expand sidebar" : "sidebar"}>
                <div className="icon-for-sidbar-expand-and-collabse">
                    <p onClick={handleExpendClick}>
                        {expnadSidbar ? <BsChevronLeft size={30} /> : <BsChevronRight size={30} />}
                    </p>
                </div>
                <SidebarList expnadSidbar={expnadSidbar} />
            </div>
            <div className="container-fluid">
                <Home  changeTheme={changeTheme} theme={theme}/>
                
            </div>

        </div>
    )
}

export default Sidebar